import VenoBox from 'venobox'
import lightboxSlider from './index'

export default function() {
	let inlinePopup = new VenoBox({
		selector: '.inline-popup',
		customClass: 'twk-inline-popup',
		numeration: false,
		infinigall: false,
		share: false,
		spinner: 'pulse',
		bgcolor: 'none',
		overlayColor: 'rgb(0 39 86 / 50%)',
    overlayClose: true,
		onContentLoaded: function(){
			lightboxSlider()
		},
	});
  document.addEventListener('click', function (event) {
    // If the clicked element doesn't have the right selector, bail
    if (!event.target.matches('.js-close-lightbox')) return;
  
    // Don't follow the link
    event.preventDefault();
  
    // close popup on click    
   inlinePopup.close(); 
  
  }, false);
}
